import styled, { createGlobalStyle, keyframes } from "styled-components";

export const HideBodyOverflow = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;

const PulseAnimation = keyframes`
  0% {
    transform: scale( .85);
  }
  20% {
    transform: scale( 1);
  }
  40% {
    transform: scale( .85);
  }
  60% {
    transform: scale( 1);
  }
  80% {
    transform: scale( .85);
  }
  100% {
    transform: scale( .85);
  }
`;

export const FullPageLoaderWrapper = styled.div`
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -10px;
    left: -10px;
    width: calc(100% + 20px);
    z-index: 2;
    background-color: ${(props) => props.theme.default.euiColorLightestShade};

    ${(props) =>
        props.fullPage &&
        `
      position: fixed;
      z-index: 99999999;
    `}

    img {
        max-width: 150px;
        transform: scale(1);
        animation-name: ${PulseAnimation};
        animation-duration: 2s;
        animation-iteration-count: infinite;
        animation-timing-function: ease-in-out;
    }
`;
